import Vue from 'vue'
import ElementUI from 'element-ui'
import './styles/element-variables.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.scss'
import './styles/iconfont/iconfont.css'
import './router/permission'

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)


import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})


Vue.use(ElementUI);

Vue.config.productionTip = false
import {ufunction} from './utils/tools'
Vue.filter('turnValToText', function (val,objKey) {
	let result=val
	let word=ufunction.wordData[objKey]
    if(!val){
		result=""
	} else if(!word){
		console.log("没有配置"+objKey+'相关数据字典')
		result="-"
	}else{
		word.forEach(function(item,index){
			if(item.value==val){
				result=item.text
				return 
			}
		})
	}
	return result
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
